import template from './truck.create.html';
import controller from './truck.create.controller';
import './truck.create.controller';

let truckcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default truckcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/truck/create/truck.create.component.js